// Utilidades reutilizables (>1 consumidor). Las utilidades exclusivas de un
// componente viven colocadas en su carpeta.

// ─── Cookies (cliente) ─────────────────────────────────────────────────────────

/** Lee una cookie por nombre en el navegador. `undefined` en server. */
export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')
  const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : undefined
}

/** Escribe una cookie en el navegador (no-op en server). `SameSite=Lax`, path raíz. */
export function setCookie(name: string, value: string, days = 365): void {
  if (typeof document === 'undefined') return
  const maxAge = days * 24 * 60 * 60
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`
}

/**
 * Borra una cookie del navegador (no-op en server).
 *
 * `path` y `SameSite` deben coincidir con los de `setCookie`: el navegador
 * identifica la cookie por nombre + dominio + path, así que borrar con un path
 * distinto del de escritura no surte efecto y dejaría la cookie viva.
 */
export function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`
}
